import { store } from '../globals';
import { lpIdGetCopy, lpIdGetPure } from './global_getter';
import lpApp from '../app/lp_app';

/*
* Project: LegalPlace assistant
* File: src/logic/ovc_converter.js
* Author: Nasreddine DAIFALLAH
* Version: 1.0
*/


// this file converts the OVC model in the local context to a Guy's format
function reindexOById(o) {
  const _ = {};
  o.forEach((idx) => {
    _[idx.id] = { flat: idx.key, value: idx.value };
  });
  return _;
}

function reindexOByFlat(o) {
  const _ = {};
  o.forEach((idx) => {
    _[idx.key] = { id: idx.id, value: idx.value };
  });

  return _;
}

function reindexFlatToKey(flat = []) {
  const _ = {};
  flat.forEach((idx) => {
    _[idx.uiid] = { parent: idx.parentId, type: idx.genre, id: idx.id };
  });
  return _;
}

function multipleFirst(id) {
  let now = id; // parseInt(id);
  while (typeof now !== 'undefined') {
    if (lpApp.references.getOption(now).meta.multiple) return now;
    now = lpApp.indexes.grandpa.getFather(now);
  }
  return false;
}

function getMultiplePosition(id) {
  const pureId = lpIdGetPure(id);
  const copy = lpIdGetCopy(id);
  const multiples = lpApp.indexes.multiples.getMultiple(multipleFirst(pureId));
  if (typeof multiples === 'undefined') return false;
  let idx = 1;
  const i = 0;
  while (multiples[i] !== copy) {
    idx += 1;
  }
  return idx;
}

// check multiples, the first multiple parent

/* eslint-disable */
// ████████╗███████╗███████╗████████╗    ████████╗██╗  ██╗███████╗    ██╗███╗   ██╗██╗████████╗██╗ █████╗ ██╗     ██╗███████╗ █████╗ ████████╗██╗ ██████╗ ███╗   ██╗
// ╚══██╔══╝██╔════╝██╔════╝╚══██╔══╝    ╚══██╔══╝██║  ██║██╔════╝    ██║████╗  ██║██║╚══██╔══╝██║██╔══██╗██║     ██║╚══███╔╝██╔══██╗╚══██╔══╝██║██╔═══██╗████╗  ██║
//    ██║   █████╗  ███████╗   ██║          ██║   ███████║█████╗      ██║██╔██╗ ██║██║   ██║   ██║███████║██║     ██║  ███╔╝ ███████║   ██║   ██║██║   ██║██╔██╗ ██║
//    ██║   ██╔══╝  ╚════██║   ██║          ██║   ██╔══██║██╔══╝      ██║██║╚██╗██║██║   ██║   ██║██╔══██║██║     ██║ ███╔╝  ██╔══██║   ██║   ██║██║   ██║██║╚██╗██║
//    ██║   ███████╗███████║   ██║          ██║   ██║  ██║███████╗    ██║██║ ╚████║██║   ██║   ██║██║  ██║███████╗██║███████╗██║  ██║   ██║   ██║╚██████╔╝██║ ╚████║
//    ╚═╝   ╚══════╝╚══════╝   ╚═╝          ╚═╝   ╚═╝  ╚═╝╚══════╝    ╚═╝╚═╝  ╚═══╝╚═╝   ╚═╝   ╚═╝╚═╝  ╚═╝╚══════╝╚═╝╚══════╝╚═╝  ╚═╝   ╚═╝   ╚═╝ ╚═════╝ ╚═╝  ╚═══╝
/* eslint-enable */

function getAllOptions() {
  const options = store.getState().output.o;
  const variables = store.getState().output.v;
  const optionsPre = store.getState().loadedOvc.oF;
  const variablesPre = store.getState().loadedOvc.vF;

  const o = {};
  const c = {};
  const v = {};

  Array.prototype.fillAtIndex = function (value, index) {
    for (let i = 0; i < index; i += 1) if (typeof (this[i]) === 'undefined') this.push('');
    this.splice(index, 1, value);

    return this;
  };


  // TODO: get the nearest grandpa multiple
  // initialization of options

  if (optionsPre) {
    Object.keys(optionsPre).forEach((idx) => {
      const { grandpa } = lpApp.indexes;
      if (idx && grandpa.getFather(lpIdGetPure(idx))) {
      // debugger//
        const par = grandpa.getFather(lpIdGetPure(idx));
        if (lpIdGetCopy(idx) !== -2) { // multiple thing
          if (typeof (o[par]) === 'object') {
            let index = 0;
            const parentMultiple = lpApp.indexes.multiples.getMultiple(par);
            if (typeof parentMultiple === 'object') index = parentMultiple.indexOf(lpIdGetCopy(idx));
            index = index > -1 ? index + 1 : 0;
            o[par].fillAtIndex(lpIdGetPure(idx), index);
          } else if (['string', 'integer'].indexOf(typeof (o[par])) > -1) {
            o[par] = [o[par], idx];
          } else if (
            lpApp.references.getOption(grandpa.getFather(lpIdGetPure(idx))).meta.multiple
          ) {
            o[grandpa.getFather(lpIdGetPure(idx))] = [idx];
          } else o[grandpa.getFather(lpIdGetPure(idx))] = idx;
        } else if (lpApp.references.getOption(grandpa.getFather(lpIdGetPure(idx))).meta.multiple) {
          o[grandpa.getFather(lpIdGetPure(idx))] = [idx];
        } else o[grandpa.getFather(lpIdGetPure(idx))] = idx;
      }
    });
  }

  options.forEach((idx) => {
    if (lpApp.references.getOption(lpIdGetPure(idx.id)).meta.type === 'radio'
      && idx.value
      && lpApp.indexes.grandpa.getFather(lpIdGetPure(idx.id))
    ) {
      // debugger
      if (lpIdGetCopy(idx.id) !== -2) { // multiple thing
        const par = lpApp.indexes.grandpa.getFather(lpIdGetPure(idx.id));
        if (typeof o[par] !== 'object') o[par] = [];
        o[par].fillAtIndex(
          lpIdGetPure(idx.id),
          lpApp.ops.ovc.getIndexOfMultiple(lpIdGetCopy(idx.id)),
        );
      } else if (multipleFirst(lpIdGetPure(idx.id))) {
        const par = lpApp.indexes.grandpa.getFather(lpIdGetPure(idx.id));
        if (typeof o[par] !== 'object') o[par] = [];
        o[par].fillAtIndex(idx.id, lpApp.ops.ovc.getIndexOfMultiple(lpIdGetCopy(idx.id)));
      } else o[lpApp.indexes.grandpa.getFather(idx.id)] = idx.id;
    }
    if (lpApp.references.getOption(lpIdGetPure(idx.id)).meta.type === 'checkbox') {
      // debugger
      if (lpIdGetCopy(idx.id) !== -2) { // multiple thing
        if (typeof c[lpIdGetPure(idx.id)] !== 'object') {
          c[lpIdGetPure(idx.id)] = [];
          const max = getMultiplePosition(idx.id);
          for (let i = 0; i < max; i += 1) {
            c[lpIdGetPure(idx.id)].push('');
          }
        }
        c[lpIdGetPure(idx.id)].push(idx.value);
        // console.log(idx.id)
        // console.log(c[lpIdGetPure(idx.id)])
      } else if (multipleFirst(lpIdGetPure(idx.id))) {
        if (typeof c[lpIdGetPure(idx.id)] === 'object') c[lpIdGetPure(idx.id)][0] = idx.value;
        else c[lpIdGetPure(idx.id)] = [idx.value];
      } else c[lpIdGetPure(idx.id)] = idx.value;
    }
  });
  if (variablesPre) {
    Object.keys(variablesPre).forEach((idx) => {
      if (lpIdGetCopy(idx) !== -2) { // multiple thing
        v[lpIdGetPure(idx)].push(variablesPre[idx]);
      } else if (multipleFirst((lpIdGetPure(lpApp.indexes.grandpa_vars.getVGrandpa(idx))))) {
        v[lpIdGetPure(idx)] = [variablesPre[lpIdGetPure(idx)]];
      } else v[lpIdGetPure(idx)] = variablesPre[lpIdGetPure(idx)];
    });
  }

  variables.forEach((idx) => {
    // console.log(idx);
    if (lpIdGetCopy(idx.id) !== -2) { // multiple thing
      if (!v[lpIdGetPure(idx.id)]) v[lpIdGetPure(idx.id)] = [];
      v[lpIdGetPure(idx.id)].fillAtIndex(
        idx.value,
        lpApp.ops.ovc.getIndexOfMultiple(lpIdGetCopy(idx.id)),
      );
    } else if (
      multipleFirst((lpIdGetPure(lpApp.indexes.grandpa_vars.getVGrandpa(lpIdGetPure(idx.id)))))
    ) {
      v[lpIdGetPure(idx.id)] = [idx.value];
    } else v[lpIdGetPure(idx.id)] = idx.value;
  });

  const cleanMultipleArray = (a, id, len, def_val = '') => {
    if (typeof a[id] === 'undefined') a[id] = [];
    else if (typeof a[id] !== 'object') a[id] = [a[id]];

    if (a[id].length < len) for (let i = a[id].length; i < len; i += 1) a[id].push(def_val);
  };

  // Cleaning multiples
  Object.keys(lpApp.indexes.multiples.multiples).forEach((idx) => {
    const multiple = lpApp.indexes.multiples.multiples[idx];
    const length = (typeof multiple === 'object' ? multiple.length : 0) + 1;
    const children = lpApp.ops.utils.getAllChildren(idx);
    const childrenVariables = lpApp.ops.utils.getAllVariableChildren([idx, ...children]);

    // Checking length
    if (lpApp.references.getOption(lpIdGetPure(idx)).meta.type === 'checkbox') cleanMultipleArray(c, idx, length, false);
    else cleanMultipleArray(o, idx, length);

    // Checking options
    children.forEach((cId) => {
      if (lpApp.references.getOption(lpIdGetPure(cId)).meta.type === 'checkbox') cleanMultipleArray(c, cId, length, false);
      else cleanMultipleArray(o, cId, length);
    });

    // Cleaning childrenVariables
    childrenVariables.forEach((cId) => {
      cleanMultipleArray(v, cId, length);
    });
  });

  return {
    o,
    v,
    c,
  };
}


window.getAllOptions = getAllOptions;
function convertToO(o = [], flat = []) {
  const _ = {};
  const c = {};
  const f = reindexFlatToKey(flat);
  o.forEach((idx) => {
    if (idx.value) {
      let cId = idx.id;
      if (typeof idx.id === 'string') {
        [cId] = idx.id.split('_');
      }
      if (idx.key in f
        && ('parent' in f[idx.key])
        && ((f[idx.key].parent > 0) || (typeof f[idx.key].parent === 'string'))
        && (f[idx.key].type === 'o')
      ) {
        let cPid = f[idx.key].parent;
        const isCheckbox = (lpApp.references.getOption(cId).meta.type === 'checkbox');
        if (typeof cPid === 'string') {
          cPid = parseInt(cPid.split('_')[0], 10);
        }
        if (isCheckbox) {
          if (cPid in c) {
            if (!c[cPid].length) {
              c[cPid] = [c[cPid], parseInt(cId, 10)];
            } else c[cPid].push(parseInt(cId, 10));
          } else if (lpApp.references.getOption(cId).meta.multiple) c[cPid] = [parseInt(cId, 10)];
          else c[cPid] = parseInt(cId, 10);
        } else
        if (cPid in _) {
          if (!_[cPid].length) {
            _[cPid] = [_[cPid], parseInt(cId, 10)];
          } else _[cPid].push(parseInt(cId, 10));
        } else if (lpApp.references.getOption(cId).meta.multiple) _[cPid] = [parseInt(cId, 10)];
        else _[cPid] = parseInt(cId, 10);
      }
    }
  });
  // console.log(_)
  // console.log(c)
  return [_, c];
}

function convertToV(v = []) {
  const _ = {};
  // let f = reindexFlatToKey(flat);
  v.forEach((idx) => {
    if (idx.value && idx.value !== '') {
      _[idx.id] = idx.value;
    }
  });
  return _;
}

// check if the parents are multiples or not
function traverseParents(id) {
  let amMultiple = false;
  let idx = id;
  while (idx >= 0) {
    if (lpApp.references.getOption((typeof idx === 'string' ? idx.split('_')[0] : idx)).meta.multiple) amMultiple = true;
    idx = (idx in window.lp_parenting_opts ? window.lp_parenting_opts[idx].parent : -10);
  }
  return amMultiple;
}

// convert the object to O array usable in the payment and document generation
function getOptionsOVC() {
  const input = window.lp_ops;
  const passOne = {};
  Object.keys(input).map(idx => (input[idx].value === 'NONE' ? null : passOne[idx] = input[idx].value));
  const passTwo = {};
  // debugger;
  Object.keys(passOne).forEach((idx) => {
    if (idx.split('_').length > 1) {
      const idDiv = idx.split('_');
      // idDiv[0] = parseInt(idDiv[0]);
      // debugger
      if (passTwo[idDiv[0]] && passTwo[idDiv[0]].length) {
        passTwo[idDiv[0]].push(passOne[idx]);
      }
    } else if (window.lp_mult[idx] || traverseParents(idx)) passTwo[idx] = [passOne[idx]];
    else {
      passTwo[idx] = passOne[idx];
    }
  });

  return passTwo;
}

function getOVC(o, v, flat) {
  const convertedO = convertToO(o, flat);
  const convertedV = convertToV(v);
  // return {o: convertedO, v: convertedV, c: _c};
  return [convertedO[0], convertedV, convertedO[1]];
}

window.getOVC = getAllOptions;

export {
  convertToO,
  reindexOByFlat,
  reindexOById,
  getOVC,
  getOptionsOVC,
  getAllOptions,
};



// WEBPACK FOOTER //
// ./src/logic/ovc_converter.js